module.exports = __webpack_public_path__ + "media/images/version_merge/logo_icon-f38a47b7b8cfb99a6ee5129e3816de51.svg";